/* eslint-disable import/prefer-default-export */
/**
 * All available routes for the app
 */

export const HOME = '/home';

export const EXPLORE = '/explore';

export const CHATS = '/chats';

export const LOGIN = '/login';

export const REGISTER = '/register';

export const RESET_PASSWORD = '/reset-password';

export const OTP_CODE = '/otpcode';

export const SET_PASSWORD = '/set-password';

export const PAGE_NOT_FOUND = '/error404';

export const SUCCESS = '/success';

export const STORE = '/store';

export const PROFILE = '/profile';
